import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import pluralize from 'pluralize';
import {
  useEstateWorkItem_GetEstateWorkItemsCountsByPortalIdQuery,
  useTaskCredit_GetCurrentTaskCreditQuery,
} from 'queries';

import Spinner from 'common/spinner';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';
type Props = {
  portalId: string;
};

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(2),
  },
  taskText: {
    fontSize: '15px',
    color: '#D351E1',
  },
  title: {
    fontSize: '48px',
  },
  subTitle: {
    fontSize: '14px',
  },
  boxItem: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    padding: '40px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
    height: '148px',
    width: '430px',
  },
}));

const TaskOverview = ({ portalId }: Props) => {
  const classes = useStyles();
  const { data: currentTaskCreditData, loading: currentTaskCreditLoading } =
    useTaskCredit_GetCurrentTaskCreditQuery({
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      variables: {
        portalId,
      },
      onError: (e) => {
        // We don't want to show a message bar here because users will get redirected from the home
        //  page to the subscription page if they don't have a subscription so showing an error
        //  would be unnecesary and potentially confusing.
        console.log('Error getting current task credit: ' + e.message);
      },
    });

  const { data: portalEstateWorkItemSummaryData, loading: portalEstateWorkItemSummaryLoading } =
    useEstateWorkItem_GetEstateWorkItemsCountsByPortalIdQuery({
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      variables: {
        portalId,
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting estate work items counts by portal ID: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (currentTaskCreditLoading || portalEstateWorkItemSummaryLoading) {
    return <Spinner />;
  }

  if (!currentTaskCreditData?.data || !portalEstateWorkItemSummaryData?.data) {
    return null;
  }

  const checkCompleted = portalEstateWorkItemSummaryData.data.completedEstateWorkItemsCount > 0;

  return (
    <Box className={classes.container}>
      {checkCompleted && (
        <Typography className={classes.taskText}>
          <strong>
            🎉 You've completed {portalEstateWorkItemSummaryData.data.completedEstateWorkItemsCount}{' '}
            {pluralize('task', portalEstateWorkItemSummaryData.data.completedEstateWorkItemsCount)}{' '}
            with Trustate!
          </strong>
        </Typography>
      )}
    </Box>
  );
};

export default TaskOverview;
